import React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import QrCodeScannerOutlinedIcon from '@mui/icons-material/QrCodeScannerOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';


export default function NavFooter() {
  const [value, setValue] = React.useState(0);

  const navigate = useNavigate();
  const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
  // console.log(value)
  return (
    <Box  >
      {/* <CssBaseline /> */}
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 3 }} elevation={2}  >
        <BottomNavigation showLabels value={value} sx={{ backgroundColor: '#f7f7f7' }} onChange={(event, newValue) => { setValue(newValue); }} >
          <BottomNavigationAction label={<Typography color={(value === 0) ? appThemeColor : 'info'} >Home</Typography>} icon={<HomeOutlinedIcon sx={{ color: (value === 0) ? appThemeColor : 'info' }} />} onClick={() => navigate('/Interpreter/Dashboard')} />
          <BottomNavigationAction label={<Typography color={(value === 1) ? appThemeColor : 'info'}  >Scan</Typography>} icon={<QrCodeScannerOutlinedIcon sx={{ color: (value === 1) ? appThemeColor : 'info' }} />}  />
          <BottomNavigationAction label={<Typography color={(value === 2) ? appThemeColor : 'info'} >Profile</Typography>} icon={<AccountCircleOutlinedIcon sx={{ color: (value === 2) ? appThemeColor : 'info' }} />} onClick={() => navigate('/Interpreter/Profile_view')} />
          <BottomNavigationAction label={<Typography color={(value === 3) ? appThemeColor : 'info'} >History</Typography>} icon={<HistoryOutlinedIcon sx={{ color: (value === 3) ? appThemeColor : 'info' }} />} />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}

